// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NavbarController from "./navbar_controller.js"
application.register("navbar", NavbarController)

import Notifly__MessageController from "./notifly/message_controller.js"
application.register("notifly--message", Notifly__MessageController)
